import {
  bytesToHex,
  decryptData,
  decryptKeyToUtf8,
  getAppKeyBytes,
  asymDecrypt,
} from "../utils/cryptoHelpers";
import { APP_ORBIT } from "../utils/constants";
import { APP_NOVA } from "../config/appConfig";
import { APP_ATLAS } from "../utils/cryptoFunction";

export const assembleValue = () =>
  atob(APP_ORBIT) +
  atob(APP_NOVA) +
  atob(APP_ATLAS);


export const getSessionContext = () => {
  const storedRaw = sessionStorage.getItem("session_context");
  return storedRaw ? JSON.parse(atob(storedRaw)) : null;
};

export const getReqResDek = async () => {
  const stored = getSessionContext();
  if (!stored?.blob) {
    return null;
  }
  return decryptData(bytesToHex(getAppKeyBytes()), stored.blob);
};


export const getSecurityLevel = async () => {
  const stored = getSessionContext();
  if (!stored?.flag) {
    return null;
  }
 return decryptKeyToUtf8(getAppKeyBytes(), stored.flag);
};

export const getClientDevicePvtKey = async () => {
  const stored = getSessionContext();
  if (!stored?.localProof) {
    return null;
  }
  const reqResDek = await getReqResDek();
  if (!reqResDek) {
    return null;
  }
  return new TextDecoder().decode(
    await decryptData(bytesToHex(reqResDek), stored.localProof)
  );
};

export const getServerPublicKey = async () => {
  const stored = getSessionContext();
  if (!stored?.remoteAnchor) {
    return null;
  }
  const reqResDek = await getReqResDek();
  if (!reqResDek) {
    return null;
  }
  return new TextDecoder().decode(
    await decryptData(bytesToHex(reqResDek), stored.remoteAnchor)
  );
};

export const getContentDek = async (apiResponse) => {
  const encContentDek = apiResponse?.contentDataEncKey;
  if (!encContentDek) {
    return null;
  }
  const clientPvtKey = await getClientDevicePvtKey();
  if (!clientPvtKey) {
    return null;
  }
  return asymDecrypt(encContentDek, clientPvtKey);
};

export const getCandidateDek = async (apiResponse = {}) => {
  const stored = getSessionContext();
  const encCandidateDek =
    stored?.sessionSeal ?? apiResponse?.candidateDataEncKey;
  if (!encCandidateDek) {
    return null;
  }
  const clientPvtKey = await getClientDevicePvtKey();
  if (clientPvtKey) {
    try {
      return await asymDecrypt(encCandidateDek, clientPvtKey);
    } catch {
      // not RSA-wrapped — fall through to the reqResDek path below
    }
  }
  const reqResDek = await getReqResDek();
  if (!reqResDek) {
    return null;
  }
  return decryptData(bytesToHex(reqResDek), encCandidateDek);
};

